import { render } from "./ThemesManagerSearchAddIndicator.vue?vue&type=template&id=13beabf2&scoped=true"
import script from "./ThemesManagerSearchAddIndicator.vue?vue&type=script&lang=js"
export * from "./ThemesManagerSearchAddIndicator.vue?vue&type=script&lang=js"

import "./ThemesManagerSearchAddIndicator.vue?vue&type=style&index=0&id=13beabf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13beabf2"]])

export default __exports__